import i18n from '@/plugins/i18n'

/** 门禁设备类型 */
const entranceGuard = [
    {
        /** 类型名称 */
        categoryName: i18n.t('entranceGuard.categoryName.cardReader'),
        /** 类型下面的子类型 */
        catgItem: [
            {
                /** 子类型唯一标识 */
                id: "CP-636456385274-sjz",
                /** 子类型展示图 */
                catgImg: require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader1.png"),
                /** 子类型名称 */
                name: i18n.t('entranceGuard.cardReader.cardKeypadFingerprint'),
                /** 子类型描述 */
                text: i18n.t('entranceGuard.cardReader.capacitiveDescription')
            },
            {
                id: "CP-636456385274-sz",
                catgImg: require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader2.png"),
                name: i18n.t('entranceGuard.cardReader.cardFingerprint'),
                text: i18n.t('entranceGuard.cardReader.capacitiveDescription')
            },
            {
                id: "CP-636456385274-sj",
                catgImg: require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/pinReader/密码读卡器 (1).jpg"),
                name: i18n.t('entranceGuard.cardReader.cardKeypad'),
                text: i18n.t('entranceGuard.cardReader.aluminumDescription')
            },
            {
                id: "CP-636456385274-s",
                catgImg: require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/swipeCardReader/刷卡读卡器 (1).jpg"),
                name: i18n.t('entranceGuard.cardReader.cardOnly'),
                text: i18n.t('entranceGuard.cardReader.aluminumDescription')
            }
        ]
    },
    {
        categoryName: i18n.t('entranceGuard.categoryName.wirelessLock'),
        catgItem: [
            {
                id: "CP-9894263426786",
                catgImg: require("@/assets/img/goods/entranceGuard/electronicLk/electronicLk1.png"),
                name: i18n.t('entranceGuard.wirelessLock.wirelessLock'),
                text: i18n.t('entranceGuard.wirelessLock.wirelessDescription')
            },
            {
                id: "CP-989897546892154",
                catgImg: require("@/assets/img/goods/entranceGuard/electronicLk/pullLocks/拉手锁1.jpg"),
                name: i18n.t('entranceGuard.wirelessLock.pullLock'),
                text: i18n.t('entranceGuard.wirelessLock.pullLockDescription')
            },
        ]
    },
    {
        categoryName: i18n.t('entranceGuard.categoryName.faceRecognition'),
        catgItem: [
            {
                id: "CP-763542674424354",
                // catgImg:require("@/assets/img/goods/entranceGuard/humanFaceRecognitionMachine/faceMachine/humanFaceRecognitionMachine1.png"),
                catgImg: require("@/assets/img/goods/entranceGuard/humanFaceRecognitionMachine/faceMachine/人脸机 (2).jpg"),
                name: i18n.t('entranceGuard.faceRecognition.faceRecognition'),
                text: i18n.t('entranceGuard.faceRecognition.faceRecognitionDescription')
            },
        ]
    },
    {
        categoryName: i18n.t('entranceGuard.categoryName.controller'),
        catgItem: [
            {
                id: "CP-636546566494474",
                // catgImg:require("@/assets/img/goods/entranceGuard/Controller/accessController/门禁控制器.png"),
                catgImg: require("@/assets/img/goods/entranceGuard/Controller/accessController/门禁控制器 (1).jpg"),
                name: i18n.t('entranceGuard.controller.accessController'),
                text: i18n.t('entranceGuard.controller.accessControllerDescription')
            },
        ]
    },
    {
        categoryName: i18n.t('entranceGuard.categoryName.openButton'),
        catgItem: [
            {
                id: "CP-598746215874651",
                catgImg: require("@/assets/img/goods/entranceGuard/contactFreeSwitch/switchButtons/开门按钮 (1).jpg"),
                name: i18n.t('entranceGuard.openButton.contactFree'),
                text: i18n.t('entranceGuard.openButton.contactFreeDescription')
            },
        ]
    }
]

export {
    entranceGuard
}
